import React from "react";
import Number from "../../../custom/Number";
import { Box, Divider } from "@material-ui/core";

const UserCommissionValue = ({ userId, amount, divider = false, fractionDigits = 2 }) => (
  <Box textAlign="right">
    <Number
      value={amount}
      fractionDigits={fractionDigits}
    />
    {userId && <small style={{ color: "#999"}}>{` (${userId})`}</small>} {divider && <Divider />}
  </Box>
);

export default React.memo(UserCommissionValue);
